<template>
<div style="margin:5px;">
  <Row>
       <div class="backTo">
         <span v-on:click="back">&lt;&lt;返回</span>
      </div>
    </Row>
      <br>
          <Row><Col span="12" offset="10"><div class="myTitle" >{{title}}</div></Col></Row>
        <br>
      <Row >
          <Col span="5" offset="19">
            <div>
             统计日期： {{createTime}}
            </div>
          </Col>
      </Row>
      <br>
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
                <template slot-scope="{ row }" slot="value">
                  <div>
                      <router-link :to="{path:'/home/main/report/TravelWebNum/', query:{createTime:createTime,name:row.keyword}}"
                      >{{row.keyword}}</router-link>
                  </div>
                </template>
              
              </Table>
          </Col>
      </Row>
    
  <ReportEdit ref="reportEdit"></ReportEdit>
 
</div>
</template>

<script>
  import ReportEdit from '@/pages/platform/report/ReportEdit';
  export default {
    components: {
        ReportEdit
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
      //返回上一层  
      back(){  
          this.$router.go(-1);
      },
      loadPage() {
         this.loading = false
        let url   = `api/report/get_report_detail`
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: 20,
            _id: this._id
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
     

      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      
   
    },
    mounted: function () {
      //console.log(row)
		  this.title =this.$route.query.reportName
      this._id = this.$route.query._id
      this.createTime =this.$route.query.createTime
       this.loadPage();
       this.loading = false
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        _id: '',
        title: '',
        createTime: '',
        columns4: [{
            type: 'index',
            title:'序号',
            width: 80,
            align: 'center',
          },
          {
            title: '类别',
            align: 'center',
            key: 'category',
            width:230
          },
          {
            title: '内容',
            align: 'center',
            key: 'title',
          },
                  
          {
            title: '数据',
            key: 'number',
            width:230,
            align: 'center',
            render:  (h, params) =>{                         
                    return h('div', [
                      h('div', {
                          style: {
                          color: 'blue',
                          cursor:'pointer',
                          },
                          on: {
                              click: () => {
                                 let _title=params.row.title
                                  if(_title=="旅游网站数量"){
                                       this.$router.push({ path: '/home/main/report/TravelWebNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="本地巡查网站旅游产品数量"){
                                       this.$router.push({ path: '/home/main/report/TravelPatrolWebNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="省内旅游产品数量"|| _title=='省内出境游旅游产品数量'||_title=='涉嫌低价游产品'||_title=='涉嫌未经许可经营旅行社业务数量'){
                                       this.$router.push({ path: '/home/main/report/TravelProvinceWebNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="省内旅游微信公众号主体数量"||_title=="省内旅游微信公众号文章数量"){
                                       this.$router.push({ path: '/home/main/report/TravelWechatSubject',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="涉及本省旅行社经营单位数量"){
                                       this.$router.push({ path: '/home/main/report/TravelWechatSubject',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="演出票务网站数量"){
                                       this.$router.push({ path: '/home/main/report/ShowWebNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="本次巡查网站演出票务信息数量"){
                                       this.$router.push({ path: '/home/main/report/ShowInfoNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="涉及本省演出票务经营单位数量"||_title=='涉嫌未经许可经营演出票务活动单位数量'){
                                       this.$router.push({ path: '/home/main/report/ShowInfoProvince',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="省内演出微信公众号主体数量"||_title=="省内演出微信公众号文章数量"){
                                       this.$router.push({ path: '/home/main/report/ShowWechatSubject',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="巡查大众点评酒吧数量"||_title=="涉嫌外籍人士违规演出数量"){
                                       this.$router.push({ path: '/home/main/report/PublicComment',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="涉嫌发布违规网络文化产品数量"){
                                       this.$router.push({ path: '/home/main/report/NetworkNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else if(_title=="巡查本省网络文化网站数量"){
                                       this.$router.push({ path: '/home/main/report/NetworkWebNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }else {
                                       this.$router.push({ path: '/home/main/report/OtherNum',
                                        query: {title: _title,_id: params.row._id,createTime:params.row.createTime}})
                                  }
                              }
                          }
                      },  params.row.number)
                      ]);
                  
                  }
          }
        ],
       
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
  .backTo{
       margin:10px 30px; 
       color: blue;
       cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/platform/report/ReportDetailed.vue